import {
  Home,
  BookOpen,
  Calculator,
  CreditCard,
  Video,
  HelpCircle,
  LogOut,
  Settings,
  Star,
  FileText,
  LucideCreditCard,
  Monitor
} from "lucide-react";

const PaymentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" ry="2"></rect>
    <line x1="2" y1="10" x2="22" y2="10"></line>
  </svg>
);

export const NAVIGATION_ITEMS = [
  {
    id: "dashboard",
    title: "Dashboard",
    path: "/landing",
    icon: Home,
    category: "main",
  },
  {
    id: "vocabulary",
    title: "শব্দ শিখুন",
    path: "/landing/word-learn",
    icon: BookOpen,
    category: "learning",
  },
  {
    id: "sentences",
    title: "বাক্য শিখুন",
    path: "/landing/sentence-learn",
    icon: FileText,
    category: "learning",
  },
  {
    id: "math",
    title: "স্কুল ক্লাস",
    path: "/landing/math-page",
    icon: Calculator,
    category: "learning",
  },
  {
    id: "report-card",
    title: "রিপোর্ট কার্ড",
    path: "/landing/report-card",
    icon: Star,
    category: "progress",
  },
  {
    id: "videos",
    title: "কম্পিউটার শিখুন",
    path: "/landing/computer",
    icon: Monitor,
    category: "learning",
  },
  {
    id: "subscription",
    title: "সাবস্ক্রিপশন",
    path: "/landing/subscription",
    icon: CreditCard,
    category: "account",
  },
  {
    id: "settings",
    title: "সেটিংস",
    path: "/landing/tab3",
    icon: Settings,
    category: "account",
  },
  {
    id: "support",
    title: "সাহায্য",
    path: "/landing/support",
    icon: HelpCircle,
    category: "account",
  },
  {
    id: "payment",
    title: "পেমেন্ট",
    path: "/payment",
    icon: LucideCreditCard,
    category: "payment",
  },
];

export const BRAND_CONFIG = {
  name: "Upskill by Semion",
  logo: "U",
  colors: {
    primary: "purple-600",
    secondary: "blue-600",
    accent: "indigo-700",
  },
};
